import { type SVGProps } from "react";

interface IProps extends SVGProps<SVGSVGElement> {}

export const LinkedIn = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      {...props}
    >
      <path
        fill="inherit"
        d="M9.801 13.591a2.3 2.3 0 0 1-.762-1.753c0-.696.255-1.307.762-1.78q.764-.71 1.968-.71c.803 0 1.432.237 1.94.71q.763.709.762 1.78c0 .713-.254 1.28-.762 1.753q-.764.71-1.94.71c-.786 0-1.459-.238-1.968-.71m4.242 2.71V30.79H9.466V16.302zm15.238 1.433q1.497 1.624 1.497 4.463v8.338H26.43v-7.75q0-1.433-.742-2.225-.742-.793-1.994-.794-1.252 0-1.995.794-.742.792-.742 2.224v7.75h-4.373V16.263h4.373v1.893q.665-.945 1.79-1.496 1.125-.55 2.532-.55 2.507 0 4.002 1.625"
      />
    </svg>
  );
};
